"use client";
import { CheckCircle, X, AlertCircle, Info, MinusCircle, HelpCircle } from 'lucide-react';
import "./Modal.css";

const Modal = ({
  show,
  onClose,
  onConfirm,
  type = "info",
  title,
  message,
  children,
  showButton = true,
  confirmLabel = "Continue",
}) => {
  if (!show) return null;

  const getIcon = () => {
    switch (type) {
      case "success":
        return <CheckCircle size={24} className="text-success" />;
      case "warning":
        return <AlertCircle size={24} className="text-warning" />;
      case "error":
        return <MinusCircle size={24} className="text-danger" />;
      default:
        return <HelpCircle size={24} className="text-info" />;
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal-content modal-content-${type}`} onClick={(e) => e.stopPropagation()}>
        {/* Centered icon only for info type */}
        {type === "info" && (
          <div className="modal-icon-centered modal-icon-centered-info">
            <HelpCircle size={24} className="text-info" />
          </div>
        )}

        <button className="modal-close" onClick={onClose}>
          <X size={20} />
        </button>

        <div className="modal-header">
          {type !== "info" && type !== "error" && type !== "warning" && type !== "success" && (
            <div className={`modal-icon-centered modal-icon-centered-${type}`}>
              {getIcon()}
            </div>
          )}
        </div>

        <div className="modal-body">
          {type === "error" && (
            <div className="modal-icon-centered modal-icon-centered-error">
              {getIcon()}
            </div>
          )}

          {type === "warning" && (
            <div className="modal-icon-centered modal-icon-centered-warning">
              {getIcon()}
            </div>
          )}

          {type === "success" && (
            <div className="modal-icon-centered modal-icon-centered-success">
              {getIcon()}
            </div>
          )}

          <h3 className="modal-title">{title}</h3>
          <p className="modal-message">{message}</p>
          {children}
        </div>

        {showButton && (
          <div className="modal-footer">
            {type === "warning" ? (
              <>
                <button className="btn btn-secondary" onClick={onClose} style={{border: "1px solid #000", marginRight: "10px"}}>
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={() => onConfirm?.()}>
                  {confirmLabel}
                </button>
              </>
            ) : (
              <button className="btn btn-primary" onClick={() => onConfirm?.()}>
                Delete
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
